export type SortDirection = 'asc' | 'desc';

export const PREDEFINED_DATE_RANGE = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
  THIS_QUARTER: 'this_quarter',
  THIS_YEAR: 'this_year',
  LAST_QUARTER: 'last_quarter',
  LAST_YEAR: 'last_year',
} as const;

export type PREDEFINED_DATE_RANGE =
  (typeof PREDEFINED_DATE_RANGE)[keyof typeof PREDEFINED_DATE_RANGE];

export type DateTimeValue = string | number | Date;

export interface TabDefinition<T extends string> {
  value: T;
}

export interface TabSearchParamOptions<T extends string> {
  tabs: readonly TabDefinition<T>[];
  defaultTab: T;
  paramName?: string;
}
export type Pagination = {
  curPage: number;
  pageTotal: number;
  itemsTotal: number;
  itemsReceived: number;
  nextPage: number;
  offset: number;
  perPage: number;
  prevPage: number;
};
